// CUSTOM JAVASCRIPT HERE
(function ($) {
    // console.log('website ready');
    $('.asset_wpdonorform').addClass("round shado");
    $('.carousel').on('touchstart', function (event) {
        var xClick = event.originalEvent.touches[0].pageX
        $(this).one('touchmove', function (event) {
            var xMove = event.originalEvent.touches[0].pageX
            if (Math.floor(xClick - xMove) > 5) {
                $(this).carousel('next')
            } else if (Math.floor(xClick - xMove) < -5) {
                $(this).carousel('prev')
            }
        })
        $('.carousel').on('touchend', function () {
            $(this).off('touchmove')
        })
    })

    var slide_to = function (dest) {
        $('html,body').animate({
            scrollTop: (Math.min(dest, $(document).height() - $(window).height()) + 'px')
        }, 500);
    }

    var $grid = $('.grid').masonry({
        itemSelector: '.brick',
        columnWidth: '.brick',
        // horizontalOrder: true,
        transitionDuration: 0
    });

    $(window).load(function () {
        // INTRO
        if (window.location.hash.length > 1) { // has hash
            var tofn = function () {
                var target = $("#_" + window.location.hash.substr(1))
                if (target.position()) {
                    slide_to(target.position().top);
                } else {
                    setTimeout(tofn, 250);
                }
            }
            setTimeout(tofn, 250);
        }
        $grid.masonry('layout');
        var $date = $('input.datepicker')
        if ($date.length > 0) {
            $date.datepicker({
                autoclose: true,
                startDate: "today",
                format: "dd/mm/yyyy",
                language: site_config.lang
            })
        }
    })
    $(document).ready(function () {
        $grid.masonry('layout');
    })
    if ($('body').hasClass("page-template-stats")) {
        $('a.stats-control').on('click', function (evt) {
            var item = $(this).data('id');
            $('.' + item).removeClass('d-none').hide(0).show(200, function () {
                $grid.masonry('layout');
            })
            $(this).hide(200)
            return false
        });
    }
    if (
        $('body').hasClass("page-template-campaign") ||
        $('body').hasClass("page-template-project") ||
        $('body').hasClass("page-template-team")
    ) {
        $('a').on('click', function () {
            var href = $(this).prop('href');
            if ($(this).hasClass('carousel-control-next') || $(this).hasClass('carousel-control-prev')) {
                return true
            } else if (href.match(/#/)) {
                var dest_position = $("#" + href.split("#")[1]).position()
                if (!!dest_position) {
                    slide_to(dest_position.top);
                    return false;
                } else {
                    return true;
                }
            }
        });

        $(document).scroll(function () {
            if ($("#_DonaConMe").length > 0) {
                var Y = $(document).scrollTop();
                var H = $(window).height();

                if (Y > $("#_DonaConMe").offset().top - H) {
                    $(".dcm-fab").addClass("d-none")
                } else {
                    $(".dcm-fab").removeClass("d-none")
                }
            }
            // menu_close();
        });
    }

    // MENU
    var hm = $('.header--main');

    var menu_close = function () {
        if (hm.hasClass('menu--open'))
            hm.removeClass('menu--open');
    }

    $('.hamburger').on('click', function () {
        hm.toggleClass('menu--open');
    });

    // $('a').on('click', function () {
    //     var href = $(this).prop('href');
    //     if (href.match(/#/)) {
    //         menu_close();
    //         var dest_position = $("#_" + href.split("#")[1]).position()
    //         if (dest_position) {
    //             slide_to(dest_position.top);
    //             $(".dropdown-menu.show").removeClass('show')
    //             return false;
    //         }
    //     }
    //     return true;
    // })

    // KNOB
    var knob_conf = {
        'width': 110,
        'height': 110,
        'font': 'Source Sans Pro',
        'fontWeight': 'normal',
        'inputColor': '#000',
        'format': function (v) {
            return v + "%";
        }
    }
    $(".knob").knob(knob_conf);

    function knob_update() {
        $('.knob').each(function () {
            var $t = $(this)
            if (!$t.hasClass('k_limit')) {
                var k_size = Math.max(120, $t.parent().parent().first(".knob-cnt").width() - 16)
                knob_conf.width = k_size;
                knob_conf.height = k_size;
                $t.trigger('configure', knob_conf);
            }
            $t.trigger('change')
        });
    }
    $(window).resize(function () {
        knob_update()
    });
    $(window).resize();

    // FILE/IMAGE UPLOAD
    $('#file').change(function (e) {
        var preview = document.getElementById('fileform-preview');

        var reader = new FileReader();
        reader.addEventListener("load", function () {
            $('.fileform-image').css("display", "none");
            $('.fileform-preview-div').removeClass("d-none");
            $('.fileform-preview-div .bg-contain').css("background-image", "url('" + reader.result + "'");
        });
        reader.readAsDataURL(this.files[0]);
    });

    // FORMS
    $(".form_login,#form_campaign,#form_register,.form_mind,#form_became,#form_password").submit(function (e) {

        e.preventDefault();

        $('.butt').prop("disabled", true);

        if ($("#description").length > 0) {
            $("#description").text(
                $('#description').trumbowyg('html')
            )
        }
        var form = $(this);
        form.find('.errors').addClass('d-none');
        var formData = new FormData(form[0]);
        $.ajax({
            type: "POST",
            url: form.attr('action'),
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            complete: function (res) {
                $('.butt').prop("disabled", false);
            },
            success: function (res) {
                var data = res.data;
                $('.butt').prop("disabled", false);
                if (res.status !== 200 && res.status !== 201) {
                    var first = false

                    for (var i in data) {
                        if (!first) {
                            first = i
                        }

                        if (form.find('.errors_' + i).length == 0) {
                            form.find('.errors_detail').removeClass('d-none').text(i + ": " + data[i][0]).addClass(
                                'alert alert-danger')
                        } else {

                            form.find('.errors_' + i).removeClass('d-none').text(data[i][0]).addClass(
                                'alert alert-danger')
                        }

                        if (i == 'detail') {
                            form.find('.errors_' + i).text(data[i])
                        }

                    }

                    if (first !== 'non_field_errors') {
                        if (first === 'name') first = '_name'
                        form.find('input[name=' + first + ']').focus()
                    }
                } else {
                    if (data.message && form.attr('class') != 'form_mind') {
                        form.find('.message').text(data.message).addClass('alert alert-success')
                        form.find('.butt').addClass('d-none')
                    } else if (data.url) {
                        window.location = data.url
                    } else {
                        window.location.reload()
                    }
                }
            }
        });
        if ($(".g-recaptcha").length > 0) {
            grecaptcha.reset()
        }
    });

    if ($('.area_filters').length > 0) {
        $('.area_filters a').each(function () {
            var t = $(this)
            t.click(function () {
                var slug = t.data('slug')
                if (t.hasClass("active")) {
                    t.removeClass("active")
                    $(".area_filtered .card").removeClass("d-none").addClass('brick')
                    filterMap(null)
                } else {
                    slugs = []
                    $('.area_filters a').removeClass("active")
                    t.addClass("active")
                    $(".area_filtered .card").each(function () {
                        var c = $(this)
                        var found = false
                        c.find(".tag-link").each(function () {
                            if ($(this).data('slug') === slug) {
                                slugs.push(c.data('slug'))
                                c.removeClass("d-none").addClass("brick")
                                found = true
                            }
                        })
                        if (!found) {
                            c.addClass("d-none").removeClass("brick")
                        }
                    })
                    filterMap(slugs, true)
                }
                $grid.masonry('layout');
                return false
            })
        })

    }

    $('#embedModal').on('shown.bs.modal', function () {
        var $modal = $('#embedModal .embeddable');
        if ($modal.hasClass('d-none')) {
            $modal.removeClass('d-none');
            $modal.find('iframe').attr('src', $modal.data('link'))
        }
    })

    var $fnopi_submit = $("#gform_submit_button_19");
    if ($fnopi_submit.length > 0) {
        $("body").append('<div class="modal fade" id="fnopi-modal" tabindex="-1" role="dialog" aria-labelledby="EmbedElement" aria-hidden="true" data-backdrop="static"><div class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content bg-neutral round shado"><div class="modal-body"><div class="row"><div class="col-12"><h2>Il caricamento dei dati potrebbe richiedere qualche minuto...</h2></div></div></div></div></div>');
        $fnopi_submit.click(function () {
            $('#fnopi-modal').modal('show');
            // return false
        })
    }
})(jQuery)


document.addEventListener('DOMContentLoaded', () => {
    const lazyLinks = document.querySelectorAll('.lazy-bg-link');

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const link = entry.target;
                const bgUrl = link.dataset.bg;
                const bgDiv = link.querySelector('.bg-image');
                if (bgDiv && bgUrl) {
                    bgDiv.style.backgroundImage = `url('${bgUrl}')`;
                }
                obs.unobserve(link);
            }
        });
    }, { rootMargin: '200px' }); // carica un po' prima

    lazyLinks.forEach(link => observer.observe(link));

    // 'target', '_blank' su dec
    const container = document.querySelector('.full-description');
    if (container) {
        const links = container.querySelectorAll('a');
        links.forEach(link => {
            link.setAttribute('target', '_blank');
        });
    }

});

// MENU

// $(".carousel-item").first().addClass("active");

// $('.carousel').carousel({
//     interval: 500
// })

// $('#carouselExample').on('slide.bs.carousel', function (e) {

//     var $e = $(e.relatedTarget);
//     var idx = $e.index();
//     var itemsPerSlide = 4;
//     var totalItems = $('.carousel-item').length;

//     if (idx >= totalItems - (itemsPerSlide - 1)) {
//         var it = itemsPerSlide - (totalItems - idx);
//         for (var i = 0; i < it; i++) {
//             // append slides to end
//             if (e.direction == "left") {
//                 $('.carousel-item').eq(i).appendTo('.carousel-inner');
//             } else {
//                 $('.carousel-item').eq(0).appendTo('.carousel-inner');
//             }
//         }
//     }
// });
